import { render, staticRenderFns } from "./goodsDsCreate.vue?vue&type=template&id=289fc356&scoped=true"
import script from "./goodsDsCreate.vue?vue&type=script&lang=js"
export * from "./goodsDsCreate.vue?vue&type=script&lang=js"
import style0 from "./goodsDsCreate.vue?vue&type=style&index=0&id=289fc356&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289fc356",
  null
  
)

export default component.exports